exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fl-back-btn,.fl-survey-new-button{background:#d06f6e;border:none;outline:none;border-radius:4px;font-size:17px;font-weight:400;padding:15px 26px;min-width:170px;width:100%;text-align:center;color:#fff;letter-spacing:1.02px}.fl-back-btn:disabled,.fl-survey-new-button:disabled{opacity:.5;color:hsla(0,0%,100%,.5)}.fl-survey-new-button{background:#d06f6e}.fl-survey-new-button:enabled:hover{background:#993d2e}.fl-back-btn{background:#aeaeae}.fl-back-btn:enabled:hover{background:#9fa19e}", ""]);

// exports
